var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { boundMethod } from 'autobind-decorator';
import { v4 as uuid } from 'uuid';
import { FlowNodeTypes } from 'components/powerFlowShared/components/types';
import { formatPortsHelper } from 'components/powerFlowShared/helpers/nodePortFormatter';
import { FlowNode, flowNodeColor, NodeTypeComponent, } from 'fable/flowEditor';
import AnnounceFromPayload from '../helpers/announceFromPayload';
import { RecordConversation as ActionModal } from '../modals/recordConversation';
const portTranslator = (node) => [
    {
        id: uuid(),
        type: 'out',
        label: 'arrow',
        connection: node.payload.nextNode || uuid(),
    },
];
export class RecordConversationNode extends NodeTypeComponent() {
    triggerEdit() {
        const { onEdit, node } = this.props;
        onEdit(node, node.nodeType);
    }
    render() {
        return (_jsx(FlowNode, { color: RecordConversationNode.color, icon: RecordConversationNode.icon, label: RecordConversationNode.label, text: _jsx(AnnounceFromPayload, { node: this.props.node, extraData: this.props.extraData }), onEdit: this.triggerEdit }));
    }
}
RecordConversationNode.icon = 'rec';
RecordConversationNode.label = 'Record conversation';
RecordConversationNode.helpText = 'All conversations after this action in the flow will be recorded. The recording will be stored under Conversations.';
RecordConversationNode.color = flowNodeColor.blue;
RecordConversationNode.translatePayload = formatPortsHelper(portTranslator);
RecordConversationNode.ActionModal = ActionModal;
RecordConversationNode.actionTrigger = { type: FlowNodeTypes.RECORD_CONVERSATION };
RecordConversationNode.updateConnection = (node, _port, newConnection) => {
    const payload = Object.assign({}, node.payload);
    payload.nextNode = newConnection;
    return Object.assign(Object.assign({}, node), { payload });
};
__decorate([
    boundMethod
], RecordConversationNode.prototype, "triggerEdit", null);
